var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCadenas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 76,
    viewBox: "0 0 50 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7247 35.5439V21.4848C46.7247 10.129 37.4862 0.887329 26.1344 0.887329H23.8656C12.5105 0.887329 3.2721 10.125 3.2721 21.4816V35.5406H0.271484V75.1126H49.7285V35.5439H46.7247ZM27.2057 54.8222V61.5608C27.2057 62.1462 26.9731 62.7077 26.5592 63.1216C26.1452 63.5356 25.5838 63.7681 24.9984 63.7681C24.413 63.7681 23.8515 63.5356 23.4376 63.1216C23.0236 62.7077 22.7911 62.1462 22.7911 61.5608V54.8189C21.8239 54.3236 21.0516 53.5172 20.5982 52.5297C20.1449 51.5421 20.0369 50.4308 20.2917 49.3744C20.5465 48.3181 21.1493 47.3782 22.003 46.7059C22.8567 46.0336 23.9117 45.6681 24.9984 45.6681C26.085 45.6681 27.1401 46.0336 27.9938 46.7059C28.8475 47.3782 29.4502 48.3181 29.7051 49.3744C29.9599 50.4308 29.8519 51.5421 29.3986 52.5297C28.9452 53.5172 28.1728 54.3236 27.2057 54.8189V54.8222ZM39.5047 35.5439H10.4993V21.4848C10.4993 14.1109 16.4957 8.11457 23.8696 8.11457H26.1344C33.5084 8.11457 39.5047 14.1109 39.5047 21.4848V35.5439Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadenas);
export default __webpack_public_path__ + "static/media/cadenas.851be5a144a26a30898452aa7f72a171.svg";
export { ForwardRef as ReactComponent };